import { render, staticRenderFns } from "./Weather1.vue?vue&type=template&id=22fac150"
import script from "./Weather1.vue?vue&type=script&lang=js"
export * from "./Weather1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports